import APIs from './index';
import { get, post } from '@/utils/request/mAxios';
import {
  DocListQuery,
  CreateDocBody, UpdateDocBody,
  DeleteDocBody, ReleaseDocBoyd,
} from '../Types';

export function getDocPlatformList(params: DocListQuery) {
  return get(APIs.getDocPlatformList, params);
}

export function createDocPlatform(data: CreateDocBody) {
  return post(APIs.createDocPlatform, data);
}

export function updateDocPlatform(data: UpdateDocBody) {
  return post(APIs.updateDocPlatform, data);
}

export function releaseDocPlatform(data: ReleaseDocBoyd) {
  return post(APIs.releaseDocPlatform, data);
}

export function deleteDocPlatform(data: DeleteDocBody) {
  return post(APIs.deleteDocPlatform, data);
}
